import { ResourcedTexts, OfficeResult } from "../SearchFilterResultData";

type OfficeResultCardProps = OfficeResult & {
  sidebarIsActive?: boolean;
  resourcedTexts: ResourcedTexts;
};

export function OfficeResultCard({
  imgUrl,
  imgAlt,
  title,
  directionsUrl,
  country,
  address,
  phone,
  email,
  resourcedTexts,
  isDistributor,
}: OfficeResultCardProps) {
  const mailtoLink = `mailto:${email}`;
  const phoneLink = `tel:${phone}`;

  return (
    <div className="result-card">
      {isDistributor && (
        <div className="result-card__distributor-label">{resourcedTexts.distributor}</div>
      )}
      <img className="result-card__image" src={imgUrl} alt={imgAlt} height="180" />
      <p className="result-card__country">{country}</p>
      <h3 className="result-card__title">{title}</h3>
      <div className="result-card__info">
        <div className="result-card__location">
          <span className="sa-icon sa-icon-location"></span>
          <div>
            {address &&
              address.map((addressItem, index) => (
                <span key={index} className="result-card__addressline">
                  {addressItem}
                </span>
              ))}
            <a className="link result-card__link" href={directionsUrl}>
              <span className="link__content link__content--reverse">
                <span className="link__icon sa-icon sa-icon-arrow-right"></span>
                {resourcedTexts.getDirections}
              </span>
            </a>
          </div>
        </div>
        <a className="link result-card__link" href={phoneLink}>
          <span className="link__content">
            <span className="link__icon sa-icon sa-icon-phone"></span>
            {phone}
          </span>
        </a>
        <a className="link result-card__link" href={mailtoLink}>
          <span className="link__content">
            <span className="link__icon sa-icon sa-icon-mail"></span>
            {email}
          </span>
        </a>
      </div>
    </div>
  );
}
